import { useGetAllPermissionsQuery } from 'src/api/redux';

/**
 * Hook to fetch all available permissions using RTK Query
 */
const useGetAllPermissions = () => {
  const { data, error, isLoading } = useGetAllPermissionsQuery();

  return {
    data,
    error,
    isLoading,
  };
};

export default useGetAllPermissions;
